<script lang="ts">
	let {
		value = $bindable(),
		quantitySalesPack,
		onchange,
		name,
		disabled = false,
	}: {
		value: number;
		quantitySalesPack?: number | null;
		min?: number;
		onchange?: (value: number) => void;
		name?: string;
		disabled?: boolean;
	} = $props();

	const pack = $derived(quantitySalesPack ?? 1);

	function increment() {
		value += pack;
		onchange?.(value);
	}
	function decrement() {
		if (value - pack < pack) return;
		value -= pack;
		onchange?.(value);
	}
</script>

<div class="flex items-stretch *:first:rounded-l *:last:rounded-r">
	{@render quantityButton('decrement')}
	<input
		type="number"
		inputmode="numeric"
		bind:value
		{name}
		min={pack}
		step={pack}
		disabled={disabled || pack > 1}
		onchange={(e) => onchange?.(Number(e.currentTarget.value))}
		class={[
			'remove-arrow z-10 w-12 cursor-pointer rounded-none! border border-neutral-300 bg-white text-center disabled:cursor-not-allowed disabled:bg-neutral-100',
		]}
	/>
	{@render quantityButton('increment')}
</div>

{#snippet quantityButton(type: 'increment' | 'decrement')}
	<button
		type="button"
		onclick={type === 'increment' ? increment : decrement}
		disabled={disabled || (type === 'decrement' && value <= pack)}
		class="cursor-pointer touch-manipulation border border-neutral-300 bg-white px-2 py-1 hover:bg-neutral-100 disabled:cursor-not-allowed disabled:bg-neutral-100"
	>
		{type === 'increment' ? '+' : '–'}
	</button>
{/snippet}
